import Vue from 'vue'
import Vuex from 'vuex'
import baseEntity from './baseEntity'

Vue.use(Vuex)

const modulesFiles = require.context('./modules', true, /\.js$/)

var modules = modulesFiles.keys().reduce((modules, modulePath) => {
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = modulesFiles(modulePath)
  modules[moduleName] = value.default
  return modules
}, {})

const entities = 'workreport workreport_workingtime repair_report schedule spare repair_request offer partner beacon checksheet_plan company_registration staff'.split(' ')
entities.forEach(e => {
  modules[e] = baseEntity(e)
})

export default new Vuex.Store({
  modules
})



// WEBPACK FOOTER //
// ./src/store/index.js